import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./assets/css/bootstrap.min.css";
import "./assets/css/flex-slider.css";
import "./assets/css/font-awesome.min.css";
import "./assets/css/owl-carousel.css";
import "./assets/css/flickity.css";
import "./assets/css/templatemo-art-factory.css";
import "./assets/css/alo-phone.css";
import "./assets/css/animate.min.css";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
